// extracted by mini-css-extract-plugin
module.exports = {"root":"CopyToClipboard_root__2EncG","toolTip":"CopyToClipboard_toolTip__ZS-WA"};